<template>
  <div class="card-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("devices.motto.title2") }}</span>
      <span v-else>编辑格言</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="poetry"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="内容" prop="content">
            <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="poetry.content">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      poetry: {
        content: ''
      },
      rules: {
        content: [
          {
            required: true,
            message: this.$t("devices.poetry.inputContent"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getMottoDetail() {
      this.$http.getMottoItemDetail({_id: this.$route.query.id}).then(ret => {
        for (let item in this.poetry) {
          this.poetry[item] = ret.data[item];
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    create() {
      this.poetry['type'] = this.$route.query.type
      this.$http.addMottoItem(this.poetry).then(res => {
        this.$router.back();
      });
    },

    edit() {
      this.poetry['_id'] = this.$route.query.id
      this.$http.editMottoItem(this.poetry).then(res => {
        this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
        this.$router.back();
      });
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getMottoDetail();
  }
};
</script>

<style lang="scss">
.card-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .card-mgt-fileName {
        margin-right: 10px;
      }
      .card-import-btn {
        margin-top: 10px;
      }
    }
  }
}
</style>
